import styled from 'styled-components';

export const ObsSummaryLeftContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - 83px);
    height: 100%;
    justify-content: space-between;
`;
